<template>
	<div class="column">
		<QuestionsHeader
			:title="'Valda Frågor'"
			:questionGroups="comQuestionGroups"
			@change="updateQuestionGroup"
		/>
		<CategoryTab
			v-for="questionGroup in comSelectedQuestionGroups"
			:key="questionGroup.id"
			:questionGroup="questionGroup"
			@removeQuestion="removeQuestion"
		/>
		<div
			class="panel-list narrow no-hover"
			v-if="selectedQuestionGroups.length == 0"
		>
			<p class="header-item">Inga frågor</p>
		</div>
	</div>
</template>

<script>
import CategoryTab from './CategoryTab';
import QuestionsHeader from './QuestionsHeader';
export default {
	components: {
		CategoryTab,
		QuestionsHeader
	},
	props: {
		selectedQuestionGroups: Array,
		questionGroups: Array
	},
	data() {
		return {
			selectedQuestionGroup: { questions: [] }
		};
	},
	computed: {
		comQuestionGroups() {
			function comparer(otherArray) {
				return function(current) {
					return otherArray.filter(function(other) {
						if (other.id === current.id) {
							current.name = other.name;

							return current;
						}

						return other.id === current.id;
					});
				};
			}
			let newGroups = this.selectedQuestionGroups.filter(
				comparer(this.questionGroups)
			);
			newGroups.unshift({ name: 'Alla', id: 0 });

			return newGroups;
		},
		comSelectedQuestionGroups() {
			let groupIndex = this.selectedQuestionGroups.findIndex(group => {
				return group.id === this.selectedQuestionGroup.id;
			});

			if (groupIndex !== -1) {
				return [this.selectedQuestionGroups[groupIndex]];
			}

			return this.selectedQuestionGroups;
		}
	},
	methods: {
		removeQuestion(question) {
			this.$emit('removeQuestion', question);
		},
		updateQuestionGroup(questionGroup) {
			this.selectedQuestionGroup = questionGroup;
		}
	},
	created() {
		this.selectedQuestionGroup = this.comQuestionGroups[0];
	}
};
</script>
